


























import { Component, Prop, Vue } from 'vue-property-decorator'
import Modal from '@/app/ui/components/Modal/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import IconSuccessCircle from '@/app/ui/assets/icon_check_circle.vue'

@Component({
  components: {
    Modal,
    Button,
    IconSuccessCircle,
  },
})
export default class CrrotwTaskGroupCancelFeedbackModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean
  @Prop({ type: String, default: '' }) readonly message!: string
  @Prop({ type: String, default: 'success' })
  readonly variant!: 'success' | 'error'

  get isError(): boolean {
    return this.variant === 'error'
  }

  onClose(): void {
    this.$emit('close')
  }
}
